import React, { Component } from 'react';
import SiteCntBarChart from './SiteCntBarChart';

class SiteCntMng extends Component {
    handleSelectedSiteID = (siteID) => {
        this.props.handleSelectedSiteID(siteID);
    };

    render() {
        const { opbSiteCnt } = this.props;
        const siteCnt = opbSiteCnt.length || 0;
        let paramOpbSiteCnt = [];
        let maxCnt = 0;

        for (let i = 0; i < 5; i++) {
            const sampleSite = {
                siteName: "",
                totalCnt: 0,
                newCnt: 0
            };

            if (i < siteCnt) {
                maxCnt = maxCnt > opbSiteCnt[i].totalCnt ? maxCnt : opbSiteCnt[i].totalCnt;
                paramOpbSiteCnt = paramOpbSiteCnt.concat(opbSiteCnt[i]);
            }
            else paramOpbSiteCnt = paramOpbSiteCnt.concat(sampleSite);
        }

        return (
            <div className="dashboard-sitecnt">
                <div className="dashboard-sitecnt-title">현장별 설치 순위</div>
                <div className="dashboard-sitecnt-contents">
                    <SiteCntBarChart opbSiteCnt={paramOpbSiteCnt} maxCnt={maxCnt + 3} handleSelectedSiteID={this.handleSelectedSiteID} />
                </div>

            </div>
        );
    }
}

export default SiteCntMng;